import { IResponseModel } from "../../IResponseModel";

export class ForgottenPasswordCompleteResponse implements IResponseModel {
}